import { render, staticRenderFns } from "./CertoErrado.vue?vue&type=template&id=a8993a22&"
import script from "./CertoErrado.vue?vue&type=script&lang=js&"
export * from "./CertoErrado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports